export default "/_next/static/images/1ab4b906e16fedb77e86c9d017ce528a.jpg";